
export const MODE_DIALOG_TAG = "MODE_DIALOG_TAG";
export const MODE_DIALOG_TAG_TYPE_EDIT = "MODE_DIALOG_TAG_TYPE_EDIT";
